// ==============================|| OVERRIDES - LINK ||============================== //

export default function Toolbar(theme) {
  return {
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: 72,
          padding: '8px 40px',
          [theme.breakpoints.up("sm")]: {
            padding: '8px 40px',
            minHeight: 72,
          },
        },
      },
      defaultProps: {
        variant: "regular",
      },
    },
  };
}
